import { TicketRITMTypes } from '../actions/ticketRITMAction';

const defaultState = {
  isLoading: true,
  isLoadingMore: false,
  countItems: 0,
  totalItems: 0,
  listRITM: [],
};

const ticketRITMReducer = (state = defaultState, action: any) => {
  const { dataRITMInit, dataMoreRITM, dataSearchRITM } = action;

  switch (action.type) {
    case TicketRITMTypes.GET_LIST_RITM_TICKET:
      return {
        ...state,
        isLoading: state.totalItems === 0,
      };

    case TicketRITMTypes.GET_LIST_RITM_TICKET_SUCCESS:
      return {
        ...state,
        isLoading: false,
        countItems: dataRITMInit.items.length,
        totalItems: dataRITMInit.totalItems,
        listRITM: dataRITMInit.items,
      };
    case TicketRITMTypes.GET_LIST_RITM_TICKET_FAIL:
      return {
        ...state,
        isLoading: false,
      };
    case TicketRITMTypes.GET_MORE_LIST_RITM:
      return {
        ...state,
        isLoadingMore: true,
      };

    case TicketRITMTypes.GET_MORE_LIST_RITM_SUCCESS:
      return {
        ...state,
        isLoadingMore: false,
        countItems: state.countItems + dataMoreRITM.items.length,
        listRITM: [...state.listRITM, ...dataMoreRITM.items],
      };
    case TicketRITMTypes.GET_MORE_LIST_RITM_FAIL:
      return {
        ...state,
        isLoadingMore: false,
      };
  
    case TicketRITMTypes.SEARCH_RITM_TICKET:
      return {
        ...state,
        isLoading: true,
      };
    case TicketRITMTypes.SEARCH_RITM_TICKET_SUCCESS:
      return {
        ...state,
        isLoading: false,
        countItems: dataSearchRITM.items.length,
        totalItems: dataSearchRITM.totalItems,
        listRITM: dataSearchRITM.items,
      };
    case TicketRITMTypes.SEARCH_RITM_TICKET_FAIL:
      return {
        ...state,
        isLoading: false,
      };
    case TicketRITMTypes.GET_MORE_LIST_RITM_WITH_SEARCH:
      return {
        ...state,
        isLoadingMore: true,
      };

    case TicketRITMTypes.GET_MORE_LIST_RITM_SUCCESS_WITH_SEARCH:
      return {
        ...state,
        isLoadingMore: false,
        countItems: state.countItems + dataMoreRITM.items.length,
        listRITM: [...state.listRITM, ...dataMoreRITM.items],
      };
    case TicketRITMTypes.GET_MORE_LIST_RITM_WITH_SEARCH_FAIL:
      return {
        ...state,
        isLoadingMore: false,
      };
  }

  return state;
};

export default ticketRITMReducer;
